export default __webpack_public_path__ + "static/SRUS YT75 - Product Specifications & Technical Data-299cf165eea99a39ce0df2d18b28e52d.pdf";